import {uuid} from "uuidv4";
import * as _ from "lodash";
import DataGenerator from "../../DataGenerator";
import {IRootModel} from "@/shared/models/abstract/IRootModel";
import {EntityType} from "@/shared/models/entityType";
import * as events from "events";
import {PropertyChangedArgs} from "@/shared/models/abstract/propertyChangedArgs";

/**
 * Abstract base class for all models.
 */
export default class RootModel extends events.EventEmitter implements IRootModel {
    get label(): string {
        return this._label;
    }

    set label(value: string) {
        this._label = value;
    }

    _id: string;
    _entityType: any;
    _name: string;
    _isVisible: boolean;
    private _label: string;

    constructor(entityType: EntityType, label: string) {
        super();
        this._id = uuid();
        this.label = label;
        this._entityType = entityType;
        this._name = DataGenerator.getName();
        this._isVisible = true;
        this.dateCreated = (new Date()).getTime();
        this.dateChanged = (new Date()).getTime();
    }

    get isGroup() {
        return this.entityType === EntityType.Group;
    }

    get isVisible() {
        return this._isVisible;
    }

    set isVisible(value) {
        this._isVisible = value;
        this.raisePropertyChanged("isVisible");
    }

    get entityType() {
        return this._entityType;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
        this.raisePropertyChanged("id");
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
        this.raisePropertyChanged("name");

    }

    raisePropertyChanged(propertyName) {
        this.emit("propertyChanged", new PropertyChangedArgs(propertyName, this));
    }

    static fromJson(json) {
        throw new Error("NodeBaseModel should not be deserialized, only derived classes.")
    }

    toJson(): any {
        return {
            id: this.id,
            name: this.name,
            entityType: this.entityType,
            dateCreated: this.dateCreated,
            dateChanged: this.dateChanged
        }
    }

    clone() {
        throw new Error("Should be implemented by inheritors.");
    }

    dateChanged: number;
    readonly dateCreated: number;
}
